export default {
  common: {
    email: 'ईमेल',
    phone: 'फ़ोन',
    phoneNumber: 'फ़ोन नंबर',
    countrySelect: 'देश चुनें',
    countryUnmodifiedNote: 'पंजीकरण के बाद देश को संशोधित नहीं किया जा सकता',
    next: 'अगला',
    back: 'वापस',
    attention: 'ध्यान दें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    modify: 'संशोधित करें',
    ignore: 'अनदेखा करें',
    firstName: 'पहला नाम',
    middleName: 'मध्य नाम',
    lastName: 'अंतिम नाम',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'महिला',
    birthday: 'जन्मदिन',
    graphicCode: 'ग्राफ़िक कोड',
    emailCode: 'ईमेल सत्यापन कोड',
    smsCode: 'एसएमएस कोड',
    smsVerificationCode: 'SMS सत्यापन कोड',
    bind: 'बाइंड',
    send: 'भेजें',
    resend: 'पुनः भेजें',
    address: 'पता',
    done: 'हो गया',
    systemMessage: 'सिस्टम संदेश',
    setting: 'सेटिंग',
    submit: 'सबमिट करें',
    language: 'भाषा',
    edit: 'संपादित करें',
    delete: 'हटाएँ'
  },
  account: {
    account: 'खाता',
    nickname: 'उपनाम',
    id: 'आईडी',
    basicInfo: 'बेसिक लेवल',
    placeholder: 'कृपया दर्ज करें',
    completed: 'पूर्ण',
    semiInfo: 'अर्ध-सत्यापित',
    fullyInfo: 'पूरी तरह से सत्यापित',
    basicTab: 'बेसिक',
    advancedTab: 'एडवांस्ड',
    linkedAccount: 'लिंक किया गया निकासी खाता',
    accountSecurity: 'मेटवॉलेट खाता और सुरक्षा',
    logout: 'लॉग आउट',
    semiToast: 'कृपया बेसिक-लेवल सत्यापन पूरा करें',
    fullyToast: 'कृपया बेसिक-लेवल \n और सेमी-सत्यापित पूरा करें',
    quickLoginTitle: 'त्वरित लॉगिन',
    cancelQuickLogin: 'আপনি কি দ্রুত লগইন নিষ্ক্রিয় করার বিষয়ে নিশ্চিত?'
  },
  accountSecurity: {
    title: 'खाता और सुरक्षा',
    payPwd: 'भुगतान पासवर्ड',
    loginPwd: 'लॉगिन पासवर्ड',
    changeEmail: 'ईमेल बदलें',
    changePhone: 'फ़ोन नंबर बदलें',
    changePayPwd: 'भुगतान पासवर्ड बदलें',
    changeLoginPwd: 'लॉगिन पासवर्ड बदलें',
    bindEmail: 'ईमेल बाइंड करें',
    bindEmailNote: 'इसे बाइंड करने के लिए ईमेल सत्यापन पास करें',
    bindEmailPlaceholder: 'वह ईमेल दर्ज करें जिसे आप बाइंड करना चाहते हैं',
    smsBindNote: 'इसे बाँधने के लिए SMS सत्यापन पास करें',
    bindPhone: 'फ़ोन नंबर बाँधें',
    smsAuthentication: 'एसएमएस प्रमाणीकरण',
    emailAuthentication: 'ईमेल प्रमाणीकरण',
    phoneVerificationNote: 'पहले वर्तमान फ़ोन नंबर सत्यापन पास करें',
    bindPhonePlaceholder: 'वह फ़ोन नंबर दर्ज करें जिसे आप बाँधना चाहते हैं',
    verificationWrongToast: 'कृपया अपना सत्यापन कोड जाँचें',
    phoneNumberEmptyToast: 'कृपया फ़ोन नंबर भरें',
    verificationCodeEmptyToast: 'कृपया कोड भरें',
    wrongCodeToast: 'गलत कोड',
    changeNote: 'कृपया इसे बदलने के लिए सत्यापन पास करें।',
    newEmailVerification: 'नया ईमेल सत्यापन',
    newEmailPlaceholder: 'अपना नया ईमेल दर्ज करें',
    change: 'बदलें',
    emailLowercaseToast: 'ईमेल लोअरकेस अक्षरों में होना चाहिए।',
    newEmailEmptyToast: 'कृपया नया ईमेल भरें',
    changeSuccessToast: 'सफलतापूर्वक बदलें',
    phonePlaceholder: 'फ़ोन दर्ज करें',
    currentEmail: 'वर्तमान ईमेल',
    passCurrentEmailVerificationFirst: 'पहले वर्तमान ईमेल सत्यापन पास करें',
    currentEmailVerification: 'वर्तमान ईमेल सत्यापन',
    smsVerification: 'एसएमएस सत्यापन',
    currentPhoneNumber: 'वर्तमान फ़ोन नंबर',
    currentPhoneVerification: 'वर्तमान फ़ोन सत्यापन',
    currentEmailAddress: 'वर्तमान ईमेल पता',
    phoneVerification: 'फ़ोन सत्यापन',
    enterVerificationCode: 'सत्यापन कोड दर्ज करें',
    newPhoneNumber: 'सत्यापन कोड दर्ज करें',
    newEmail: 'नई ईमेल'
  },
  withdrawAccount: {
    selectAccountType: 'खाता प्रकार चुनें',
    noBasicLevelVerificationDialog: 'कृपया कैश आउट विधि को बाइंड करने से पहले बेसिक लेवल सत्यापन पूरा करें।',
    bindNote: 'कृपया सही खाता जानकारी भरें, अन्यथा आपकी निकासी प्रभावित होगी।',
    bindBankAccount: 'बैंक खाता बाँधें',
    bindMobileMoneyAccount: 'मोबाइल मनी खाता बाँधें',
    fieldEmptyToast: '{0} आवश्यक है',
    fieldLengthToast: '{0} में कम से कम {1} वर्ण होने चाहिए',
    bindBankRepeatToast: 'एक ही बैंक खाते को बार-बार बाँधें नहीं!',
    accountName: 'खाता नाम',
    ifscCode: 'IFSC कोड',
    accountEmptyToast: 'खाता आवश्यक है',
    accountNameEmptyToast: 'खाता नाम आवश्यक है',
    phoneEmptyToast: 'फ़ोन आवश्यक है',
    emailEmptyToast: 'ईमेल आवश्यक है',
    ifscCodeEmptyToast: 'IFSC कोड आवश्यक है',
    ifscCodeLengthToast: 'IFSC कोड 11 अंकों का होना चाहिए',
    bindIMPSRepeatToast: 'एक ही IMPS खाते को बार-बार बाइंड न करें!',
    bindNote2:
      'कृपया अपना सही TRC-20 पता भरें। गलत पता भुगतान खो जाने का कारण बनेगा, जिसकी हम कोई जिम्मेदारी नहीं लेते।',
    usdtAddress: 'USDT पता (TRC-20):',
    minimumLimit: 'प्रति लेनदेन के लिए न्यूनतम निकासी: $10',
    usdtFee: 'शुल्क: वास्तविक शुल्क के अधीन',
    registerGcash: 'यदि आपके पास Gcash खाता नहीं है, तो कृपया पंजीकरण करने के लिए यहाँ क्लिक करें।',
    registerEpay: 'यदि आपके पास Epay खाता नहीं है, तो कृपया पंजीकरण करने के लिए यहाँ क्लिक करें।',
    bindThirdPartyTitle: '{0} खाता बाँधें',
    wrongAccountToast: 'गलत खाता',
    accountFormatToast: 'खाता प्रारूप गलत है',
    bindThirdPartyFailedToast: '{0} बाँधना विफल हुआ',
    queryFailedToast: 'क्वेरी विफल।',
    editFailedToast: 'संपादित करने में विफल।',
    add: 'जोड़ें',
    confirmEditDialog: 'क्या आप खाता {0} संपादित करना सुनिश्चित करते हैं?',
    payPwdRequireDialog: 'कृपया खाता जोड़ने से पहले 6-अंकीय भुगतान पासवर्ड सेट करें।',
    unbindFailedToast: 'अनबाइंडिंग विफल',
    cashOutSuccessNote: 'अनुमानित आगमन समय: 7 कार्य दिवसों के भीतर',
    requestSubmitted: 'निकासी अनुरोध जमा किया गया',
    amountLimitToast1: 'कैश आउट राशि ≥$40.00 होनी चाहिए',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'कैश आउट राशि ≥${0}.00 होनी चाहिए',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'सुझाव: निकासी से पहले राशि को ${0} तक जमा करने से आपकी प्रोसेसिंग फीस प्रभावी रूप से बच जाएगी।',
    amountNotEnoughToast: 'कैश आउट राशि पर्याप्त नहीं है',
    exceedingLimitToast1: 'आज कैश आउट राशि ऊपरी सीमा तक पहुँच गई है',
    exceedingLimitToast2:
      'आज कैश आउट राशि ऊपरी सीमा तक पहुँच गई है। क्या आपको सीमा बढ़ाने के लिए उन्नत प्रमाणीकरण पूरा करने की आवश्यकता है?',
    restrictedCountriesPayPalAccountToast:
      'प्रतिबंधित देशों के PayPal खाते का उपयोग न करें, जिससे आपका Arripay ब्लॉक हो जाएगा',
    withdrawMinimumToast: 'प्रति लेनदेन के लिए न्यूनतम निकासी:$40',
    bankNotAvailableToast: 'यह बैंक अब उपलब्ध नहीं है, कृपया अन्य बैंकों को जोड़ें।',
    usdtAccountInvalidToast: 'यह USDT खाता निकासी करने में असमर्थ है, कृपया निकासी के लिए एक नए खाते का उपयोग करें।',
    noPayPwdToast: 'कृपया कैश-आउट से पहले 6-अंकीय भुगतान पासवर्ड सेट करें।',
    editBankAccount: 'बैंक खाता संपादित करें',
    accountPlaceholder: 'अपना खाता दर्ज करें',
    trc20Placeholder: 'TRC-20 पता दर्ज करें',
    accountRepeatToast: 'वर्तमान पासवर्ड के समान ही।',
    unbindBankCardConfirmDialog: 'क्या आप बैंक कार्ड {0} को अनबाइंड करना सुनिश्चित करते हैं?',
    unbindMobileMoneyAccountConfirmDialog: 'क्या आप मोबाइल मनी अकाउंट {0} को अनबाइंड करना सुनिश्चित करते हैं?',
    unbindAccountConfirmDialog: 'क्या आप अकाउंट {0} को अनबाइंड करना सुनिश्चित करते हैं?',
    availableBalance: 'उपलब्ध शेष राशि {0}',
    estimatedFee: 'अनुमानित शुल्क',
    submitFailToast: 'सबमिट विफल',
    disabledMethodToast: 'यह चैनल अस्थायी रूप से अनुपलब्ध है',
    channelUnavailableTitle: 'चैनल उपलब्ध नहीं',
    channelUnavailableNote: 'यह निकासी चैनल अस्थायी रूप से अनुपलब्ध है। कृपया कोई अन्य तरीका आज़माएँ।',
    channelUnavailableOk: 'ठीक है',
    bankTransferUnavailableTitle: 'बैंक ट्रांसफर उपलब्ध नहीं',
    bankTransferUnavailableNote:
      'आपके खाते के लिए बैंक ट्रांसफर अभी उपलब्ध नहीं है। कृपया निकासी के लिए Epay इस्तेमाल करें।',
    channelMaintenanceTitle: 'चैनल रखरखाव में है',
    channelMaintenanceNote: 'यह निकासी चैनल रखरखाव में है। कृपया कोई अन्य तरीका आज़माएँ।',
    bankInfoUpdateTitle: 'अपनी बैंक जानकारी अपडेट करें',
    bankInfoUpdateNote: 'बैंक की नीति समायोजन के कारण, जारी रखने के लिए कृपया अपने बैंक विवरण अपडेट करें।',
    bindEpay: 'Epay बाँधें',
    useEpay: 'Epay इस्तेमाल करें',
    iMPSMaxLimitToast: 'इस चैनल के माध्यम से एकल लेनदेन के लिए अधिकतम निकासी राशि $260 है',
    linkedAccount: 'खाता जोड़ा गया',
    otherAccounts: 'अन्य खाते जोड़े जा सकते हैं',
    withdrawTo: 'स्थानांतरित करें',
    withdrawAmount: 'राशि स्थानांतरित करें',
    withdrawable: 'निकासी योग्य',
    documentIdToast: 'आईडी नंबर में केवल संख्याएँ हो सकती हैं',
    noAvailableMethodNote: 'कोई उपलब्ध निकासी विधि नहीं है',
    recommended: 'अनुशंसित'
  },
  paymentCode: {
    changePayPwd: 'भुगतान पासवर्ड बदलें',
    setPayPwd: 'भुगतान पासवर्ड सेट करें',
    setPayPwdNote: 'कृपया 6-अंकीय भुगतान पासवर्ड सेट करें',
    reenterPayPwdNote: 'फिर से दर्ज करें',
    verificationNote: 'कृपया इसे सेट करने के लिए सत्यापन पास करें।',
    emailVerification: 'ईमेल सत्यापन',
    inconsistentPasswordToast: 'असंगत पासवर्ड',
    payPwdNote: 'कृपया भुगतान पासवर्ड दर्ज करें',
    payPwdFormatToast: 'भुगतान पासवर्ड 6-अंकीय संख्या है',
    payPwdWrongToast: 'गलत भुगतान पासवर्ड',
    payPwdVerificationFailToast: 'भुगतान पासवर्ड सत्यापन विफल!',
    successToast: 'सेट \n सफलतापूर्वक'
  },
  authorize: {
    requirement:
      '{0} को आपके लिए संबंधित सेवा प्रदान करने के लिए आपके मेटवॉलेट{1} की निम्नलिखित जानकारी प्राप्त करने की आवश्यकता है। उपनाम, अवतार, लिंग आदि।',
    authorize: 'अधिकृत करें',
    switchAccount: 'खाता बदलें',
    goToMetWallet: 'मेटवॉलेट पर जाएँ',
    notMatchTips: 'ऑपरेशन विफल हुआ। आप केवल अपने बाउंड MetWallet खाते के साथ त्वरित लॉगिन सक्षम कर सकते हैं'
  },
  basicLevel: {
    namePlaceholder: 'कोई प्रतीक, संख्या नहीं',
    verification: 'सत्यापन',
    whatsAvailable: 'क्या उपलब्ध है',
    cashOut: 'नकद निकासी',
    withdrawLimit: '$50 प्रति दिन',
    basicLevelNote: 'कृपया अपनी वास्तविक व्यक्तिगत जानकारी दर्ज करें। गलत जानकारी से निकासी विफल हो सकती है।',
    fieldEmptyToast: 'कृपया सभी आवश्यक फ़ील्ड भरें।',
    successToast: 'सहेजा गया \nसफलतापूर्वक',
    failToast: 'सहेजने में विफल',
    confirmDialog: 'अपनी वास्तविक व्यक्तिगत जानकारी दर्ज करना सुनिश्चित करें। गलत जानकारी से निकासी विफल हो सकती है',
    birthdayFormatToast: 'गलत जन्मदिन फ़ील्ड प्रारूप',
    verificationCodeError: 'सत्यापन कोड त्रुटि',
    verificationCodeEmpty: 'सत्यापन कोड रिक्त',
    noEmailCodeToast: 'कृपया ईमेल सत्यापन कोड प्राप्त करें',
    checkDialogTitle: 'अपनी जानकारी जांचें',
    checkDialogContent: 'सफलतापूर्वक निकासी के लिए, कृपया अपनी जानकारी जांचें। गलत जानकारी से निकासी विफल हो सकती है।',
    check: 'जांचें'
  },
  semiVerified: {
    uploadPhotoId: 'फ़ोटो आईडी अपलोड करें',
    photoId: 'फ़ोटो आईडी',
    resubmit: 'पुनः सबमिट करें',
    limit: '$5,000 प्रति दिन',
    uploading: 'अपलोड हो रहा है...',
    notUploadProofToast: 'कृपया आईडी कार्ड का प्रमाण अपलोड करें'
  },
  fullyVerified: {
    frontOfId: 'आईडी का अगला भाग',
    backOfId: 'आईडी का पिछला भाग',
    uploadIdFront: 'आईडी का अगला भाग अपलोड करें',
    uploadIdBack: 'आईडी का पिछला भाग अपलोड करें',
    withdrawDailyHint: 'निकासी के लिए जानकारी भरें > {0} प्रति दिन।',
    notUploadIdToast: 'कृपया आईडी के आगे और पीछे दोनों अपलोड करें',
    proofTitle: 'निवास प्रमाण पत्र',
    acceptableProof: 'निवास प्रमाण पत्र स्वीकार्य है:',
    acceptableProof1: 'बैंक खाता विवरण।',
    acceptableProof2: 'उपयोगिता बिल (बिजली, पानी, इंटरनेट, आदि)।',
    acceptableProof3: 'सरकार द्वारा जारी किया गया दस्तावेज़ (कर विवरण, निवास प्रमाण पत्र, आदि)।',
    unacceptableProof:
      'हम आपके द्वारा सबमिट किए गए पहचान दस्तावेज़ पर दिए गए पते को निवास के वैध प्रमाण के रूप में स्वीकार नहीं कर सकते।',
    limit: '$10,000 प्रति दिन',
    notUploadToast: 'कृपया निवास प्रमाण पत्र अपलोड करें',
    incorrectFormatToast: 'कृपया jpg/png/jpeg चित्र अपलोड करें।'
  },
  loginAndRegister: {
    pwd: 'पासवर्ड',
    lastLogin: 'अंतिम लॉगिन',
    moreOptions: 'अधिक विकल्प',
    agreeCheckboxContent: '{0} और {1} से सहमत हों',
    userAgreement: 'उपयोगकर्ता अनुबंध',
    privacyPolicy: 'गोपनीयता नीति',
    notAgreeToast: 'उपयोगकर्ता अनुबंध और गोपनीयता नीति से सहमत हों',
    forgotPassword: 'पासवर्ड भूल गए',
    linkedMail: 'लिंक किया गया मेल',
    verificationCode: 'सत्यापन कोड',
    newPwd: 'नया पासवर्ड',
    repeatPwd: 'पासवर्ड दोहराएँ',
    confirmPwd: 'पासवर्ड की पुष्टि करें',
    noLinkedEmailToast: 'आपके खाते से कोई लिंक किया गया ईमेल नहीं है',
    unregisteredToast: 'यह नंबर पंजीकृत नहीं किया गया है',
    pwdFormatToast: 'पासवर्ड का प्रारूप गलत है',
    resetSuccessToast: 'रीसेट \n सफलतापूर्वक',
    pwdNotMatchToast: 'पासवर्ड दो बार मेल नहीं खाते',
    emailFormatToast: 'गलत ईमेल प्रारूप',
    phoneNumberFormatToast: 'गलत फ़ोन नंबर प्रारूप',
    invalidAreaCodeToast: 'अमान्य क्षेत्र कोड',
    login: 'लॉग इन करें',
    pwdLogin: 'पासवर्ड के माध्यम से लॉग इन करें',
    emailCodeLogin: 'ईमेल सत्यापन कोड के माध्यम से लॉग इन करें',
    smsLogin: 'एसएमएस के माध्यम से लॉग इन करें',
    verifyEmail: 'ईमेल सत्यापित करें',
    verifyPhone: 'फ़ोन सत्यापित करें',
    accountDangerDialog:
      'आपके खाते में ख़तरा पाया गया है। कृपया अपने खाते को फिर से सत्यापित करें, अन्यथा आपका खाता उपयोग में नहीं लाया जा सकेगा।',
    sendEmailCodeDialog: 'हमने आपके {0} ईमेल पर एक सत्यापन कोड भेजा है। कृपया सत्यापन कोड दर्ज करें।',
    sendSmsCodeDialog: 'हमने आपके {0} फ़ोन पर एक सत्यापन कोड भेजा है। कृपया सत्यापन कोड दर्ज करें।',
    graphicCodeEmptyToast: 'कृपया ग्राफ़िक कोड दर्ज करें।',
    countryUnselectToast: 'कृपया पहले अपना देश चुनें',
    unsupportedLoginTypeToast: 'असमर्थित लॉगिन प्रकार',
    pwdWrongLimitOverDialog:
      'गलत पासवर्ड 3 बार दर्ज किया गया है। कृपया लॉग इन करने के लिए एसएमएस सत्यापन कोड का उपयोग करें।',
    loginFailedToast: 'लॉग इन विफल',
    signIn: 'साइन इन करें',
    pwdPlaceholder: 'पासवर्ड दर्ज करें',
    pwdNote: '8-16 अक्षर दर्ज करें (अक्षर और संख्याएँ शामिल)',
    reenterPwdPlaceholder: 'पासवर्ड फिर से दर्ज करें',
    reenterPwdNote: 'कृपया पासवर्ड फिर से दर्ज करें',
    createAccount: 'खाता बनाएँ',
    chooseCountryNote: 'कृपया देश चुनें',
    pwdInconsistentToast: 'आपके द्वारा दर्ज किए गए पिछले पासवर्ड के समान नहीं',
    createSuccessToast: '\n सफलतापूर्वक बनाएँ',
    registerFailToast: 'पंजीकरण विफल',
    userNotExistToast: 'उपयोगकर्ता मौजूद नहीं है',
    phoneIncorrectToast: 'कृपया अपना फ़ोन जांचें',
    userExistToast: 'उपयोगकर्ता पहले से मौजूद है',
    countryCodeRepeatToast: 'कृपया देश कोड बार-बार दर्ज न करें!',
    logoutDialog: 'क्या आप लॉग आउट करना सुनिश्चित करते हैं?',
    pwdRequirement: 'पासवर्ड में कम से कम 8 से 16 अक्षर और संख्याएँ होनी चाहिए',
    signup: 'साइन अप करें',
    registerSuccessToast: 'रजिस्टर \n सफलतापूर्वक',
    oldPwdErrorToast: 'कृपया अपना पुराना पासवर्ड जांचें'
  },
  checkUserInfo: {
    title: 'प्रबंधन केंद्र',
    emptyInfoNote:
      'यहाँ चालू खाते के लिए कोई जानकारी नहीं है, कृपया उस मेटवॉलेट खाते की जाँच करें जिसे आपको सत्यापित करने की आवश्यकता है।',
    infoNote: 'यहाँ आपकी सत्यापन जानकारी है।',
    lastSuccessWithdrawal: 'अंतिम सफल निकासी',
    copyBtn: 'कॉपी करें',
    successToast: 'सफलतापूर्वक कॉपी किया गया!',
    failToast: 'कॉपी करने में विफल!'
  },
  country: {
    title: 'क्षेत्र चुनें',
    popular: 'लोकप्रिय'
  },
  documentDetails: {
    title: 'दस्तावेज़ विवरण',
    contract: 'अनुबंध',
    goToSign: 'इस पर हस्ताक्षर करने के लिए जाएँ',
    download: 'डाउनलोड करें',
    upload: 'अपलोड करें',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., केवल दस्तावेज़।',
    contentEmptyToast: 'कृपया सामग्री दर्ज करें',
    placeOfBirth: 'जन्म स्थान',
    occupation: 'व्यवसाय',
    fileForm: '(फ़ाइल फ़ॉर्म)',
    proofOfAddress: 'अंग्रेजी में पते का प्रमाण',
    residenceDoc: 'निवास दस्तावेज़',
    textForm: '(टेक्स्ट फ़ॉर्म)',
    contractAgent: 'अनुबंध एजेंट',
    contractPayslip: 'अनुबंध पेस्लिप',
    uncompletedToast: 'कृपया इसे सबमिट करने के लिए पूरा करें',
    successToast: 'सफलतापूर्वक सबमिट करें',
    undefinedFileTypeToast: 'अपरिभाषित फ़ाइल अपलोड प्रकार',
    uploadFailToast: 'अपलोड विफल'
  },
  filters: {
    amount: 'राशि',
    filter: 'फ़िल्टर',
    time: 'समय',
    reset: 'रीसेट',
    timePickerTitle: '{0} समय चुनें',
    start: 'शुरू',
    end: 'समाप्त',
    maximum: 'अधिकतम',
    minimum: 'न्यूनतम'
  },
  home: {
    balance: 'शेष राशि',
    transactions: 'लेनदेन',
    availableBalance: 'उपलब्ध शेष राशि',
    noWithdrawalMethodToast: 'कम से कम एक निकासी विधि की आवश्यकता है।',
    linkAccount: 'खाता लिंक करें',
    all: 'सभी',
    cashIn: 'नकद में',
    loading: 'लोड हो रहा है...',
    noMore: 'कोई और लेन-देन नहीं',
    reload: 'लोड हो रहा है, पुनः लोड करने के लिए क्लिक करें',
    receivedFrom: 'से प्राप्त हुआ',
    transferredTo: 'को स्थानांतरित किया गया',
    fee: 'को स्थानांतरित करने के लिए शुल्क',
    myEmail: 'मेरा ईमेल',
    myPhone: 'मेरा फ़ोन',
    invalidBasicLevelDialog:
      'आपके नाम फ़ील्ड में प्रतीकों, रिक्त स्थान या संख्याओं को शामिल करने के कारण, खाते से निकासी संभव नहीं है। कृपया बुनियादी जानकारी फिर से भरें (सुनिश्चित करें कि नाम में प्रतीक, रिक्त स्थान या संख्याएँ शामिल न हों और यदि आपका कोई पारिवारिक या मध्य नाम नहीं है, तो इसे खाली छोड़ दें।)',
    lackLastNameDialog: 'आपका अंतिम नाम नहीं भरा गया है, जो आपकी निकासी में बाधा उत्पन्न करेगा।',
    fillIn: 'भरें',
    viewDetails: 'विवरण देखें',
    docReviewingDialogTitle: 'कृपया दस्तावेज़ के पारित होने की प्रतीक्षा करें।',
    docReviewingDialogContent:
      'आपने दस्तावेज़ जमा कर दिया है, लेकिन आप अपने दस्तावेज़ के पारित होने से पहले मेटवॉलेट का उपयोग नहीं कर सकते।<br>आधिकारिक कर्मचारी इसे जल्द ही संसाधित करेंगे, कृपया थोड़ी देर प्रतीक्षा करें।',
    docPassedDialog:
      'आपके द्वारा जमा किया गया दस्तावेज़ पारित हो गया है। <br>अब आप सामान्य रूप से मेटवॉलेट का उपयोग कर सकते हैं।',
    docUnqualifiedDialog: 'आपके द्वारा जमा किया गया दस्तावेज़ अयोग्य है। <br>कृपया योग्य दस्तावेज़ जमा करें।',
    goToSubmit: 'जाएँ इसे जमा करें',
    uncompletedDialog: 'मेटवॉलेट का सामान्य रूप से उपयोग करने के लिए आपको इसे पूरा करना होगा',
    useMetWalletNormallyAfterPassed: 'दस्तावेज़ के पारित होने के बाद आप सामान्य रूप से मेटवॉलेट का उपयोग कर सकते हैं।',
    requireSemiVerifiedDialog:
      '{0}, बैंक की आवश्यकता के अनुसार, आपको सफल निकासी के लिए 48 घंटों में अर्ध-सत्यापित भाग पूरा करना होगा।',
    goToVerify: 'जाएँ सत्यापित करें',
    emailInvalidDialog:
      '{0}, आपका ई-मेल पता किसी अन्य व्यक्ति के समान है। गोपनीयता बीमा के लिए, कृपया जल्द से जल्द अपना ई-मेल पता दर्ज करें।',
    later: 'बाद में',
    transferRequireSemiVerifiedDialog: 'कृपया स्थानांतरण से पहले अर्ध-सत्यापित सत्यापन पूरा करें।',
    modifyBtnText: 'मेरी जानकारी संशोधित करें',
    unmodifiedTitle: 'संशोधित करने में असमर्थ',
    unmodifiedContent: 'आपके पास प्रक्रिया में एक निकासी आदेश है। अभी जानकारी संशोधित नहीं की जा सकती।'
  },
  signing: {
    signature: 'हस्ताक्षर',
    date: 'तारीख',
    employeeName: 'कर्मचारी का नाम',
    designation: 'पदनाम',
    month: 'महीना',
    year: 'वर्ष',
    earnings: 'आय',
    deductions: 'कटौतियाँ',
    basic: 'बेसिक और डीए (यूएसडी)',
    totalAddition: 'कुल जोड़',
    totalDeduction: 'कुल कटौती',
    salary: 'नेट वेतन',
    refNo: 'संदर्भ संख्या',
    paymentTransferDate: 'भुगतान हस्तांतरण तिथि',
    nameOfBank: 'बैंक का नाम',
    signatureOfEmployee: 'कर्मचारी का हस्ताक्षर',
    director: 'निदेशक',
    signNote: 'कृपया अपना नाम हस्ताक्षर करें',
    preview: 'पूर्वावलोकन',
    clear: 'साफ़ करें',
    save: 'सहेजें',
    noSignatureToast: 'आप हस्ताक्षर के बिना सहेज नहीं सकते।',
    fieldEmptyToast: 'कृपया सभी जानकारी भरें।'
  },
  transactionDetail: {
    title: 'लेनदेन विवरण',
    status: 'स्थिति',
    pending: 'लंबित',
    completed: 'पूर्ण',
    success: 'सफल',
    failed: 'विफल',
    cancelled: 'रद्द',
    onHold: 'होल्ड पर',
    reason: 'स्थिति कारण',
    description: 'विवरण',
    creationDate: 'निर्माण तिथि',
    lastStatusDate: 'अंतिम स्थिति तिथि',
    requestedAmount: 'अनुरोधित राशि',
    receiveAmount: 'प्राप्त राशि',
    transferAmount: 'स्थानांतरण राशि',
    amountToPay: 'भुगतान की जाने वाली राशि',
    transferFee: 'स्थानांतरण शुल्क',
    processingFee: 'प्रसंस्करण शुल्क',
    method: 'विधि',
    country: 'देश',
    name: 'नाम',
    bankPendingText: 'अंतिम बैंक समीक्षा के तहत',
    pendingText: '{0} समीक्षा के तहत',
    chametSalary: 'चामेट वेतन',
    userSalary: 'उपयोगकर्ता वेतन',
    comm: 'कॉम.',
    gemgalaSalary: 'गेमगला का वेतन'
  },
  transfer: {
    title: 'मेटवॉलेट खाते में',
    noPayPwdDialog: 'कृपया स्थानांतरण से पहले 6 अंकों का भुगतान पासवर्ड सेट करें।',
    records: 'रिकॉर्ड',
    cashInOut: 'कैश इन {0}, कैश आउट {1}',
    transfer: 'ट्रांसफर',
    fee: 'फीस',
    remark: 'टिप्पणी',
    transferTo: 'ट्रांसफर करें {0}',
    remarkPlaceholder: 'ट्रांसफर टिप्पणी जोड़ें (100 से कम अक्षर)',
    firstNameNote: 'कृपया उसका पहला नाम दर्ज करें',
    sendingAmount: 'भेजने की राशि',
    receivingAmount: 'प्राप्त करने की राशि',
    transferNow: 'अभी ट्रांसफर करें',
    noBalanceToast: 'ट्रांसफर राशि बैलेंस राशि से बड़ी है।',
    amountTooLittleToast: 'ट्रांसफर राशि $10 से कम नहीं हो सकती।'
  },
  bankData: {
    beneficiaryName: 'लाभार्थी का नाम',
    beneficiaryNamePlaceholder: 'नाम दर्ज करें',
    beneficiaryLastname: 'लाभार्थी का अंतिम नाम',
    beneficiaryLastnamePlaceholder: 'अंतिम नाम दर्ज करें',
    bankCode: 'बैंक कोड',
    bankCodePlaceholder: 'बैंक कोड चुनें',
    bankIFSCCode: 'बैंक IFSC कोड',
    bankIFSCCodePlaceholder: 'बैंक IFSC दर्ज करें',
    bankAccount: 'बैंक खाता',
    bankAccountPlaceholder: 'बैंक खाता दर्ज करें',
    email: 'ईमेल',
    emailPlaceholder: 'ईमेल दर्ज करें',
    phoneNumber: 'फ़ोन नंबर',
    phoneNumberPlaceholder: 'फ़ोन नंबर दर्ज करें',
    address: 'पता',
    addressPlaceholder: 'पता दर्ज करें',
    city: 'शहर',
    cityPlaceholder: 'शहर दर्ज करें',
    state: 'राज्य',
    statePlaceholder: 'राज्य दर्ज करें',
    postCode: 'पोस्ट कोड',
    postCodePlaceholder: 'पोस्ट कोड दर्ज करें',
    documentId: 'दस्तावेज़ आईडी',
    documentIdPlaceholder: 'दस्तावेज़ आईडी दर्ज करें',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'दस्तावेज़ प्रकार',
    documentTypePlaceholder: 'दस्तावेज़ प्रकार चुनें',
    accountType: 'खाता प्रकार',
    accountTypePlaceholder: 'खाता प्रकार चुनें',
    cpfcnpjPlaceholder: 'CPFCNPJ दर्ज करें',
    bankBranch: 'बैंक शाखा',
    bankBranchPlaceholder: 'बैंक शाखा दर्ज करें',
    ribOfBankAccount: 'बैंक खाते का RIB',
    bankName: 'बैंक का नाम',
    bankNamePlaceholder: 'बैंक का नाम दर्ज करें',
    bicCode: 'BIC कोड',
    bicCodePlaceholder: 'BIC कोड दर्ज करें',
    ibanPlaceholder: 'IBAN दर्ज करें',
    bankSwift: 'बैंक स्विफ्ट',
    bankSwiftPlaceholder: 'बैंक स्विफ्ट दर्ज करें',
    name: 'नाम',
    documentCountry: 'दस्तावेज़ देश',
    documentCountryPlaceholder: 'दस्तावेज़ देश चुनें',
    issueDate: 'दस्तावेज़ जारी करने की तिथि',
    issueDatePlaceholder: 'जारी करने की तिथि चुनें',
    expireDate: 'दस्तावेज़ की समाप्ति तिथि',
    expireDatePlaceholder: 'समाप्ति तिथि चुनें',
    bankBranchName: 'बैंक शाखा का नाम',
    bankBranchNamePlaceholder: 'शाखा का नाम दर्ज करें',
    branchPlaceholder: 'शाखा दर्ज करें',
    gender: 'लिंग',
    genderPlaceholder: 'लिंग चुनें',
    birthday: 'जन्मदिन',
    birthdayPlaceholder: 'चुनें जन्मदिन',
    phone: 'फ़ोन',
    bankAddress: 'बैंक पता',
    bankAddressPlaceholder: 'बैंक पता दर्ज करें',
    bankAccountName: 'बैंक खाता नाम',
    bankAccountNamePlaceholder: 'बैंक खाता नाम दर्ज करें',
    province: 'प्रांत',
    provincePlaceholder: 'प्रांत दर्ज करें',
    postalCode: 'पोस्टल कोड',
    postalCodePlaceholder: 'पोस्टल कोड दर्ज करें',
    savingsAccount: 'बचत खाता',
    abaRoutingNumber: 'ABA रूटिंग नंबर',
    englandBankAccount: 'इंग्लैंड बैंक खाता',
    bankBranch2: 'बैंक शाखा',
    bankBranch2Placeholder: 'केवल अगर बैंक सैंटेंडर है',
    paternalName: 'पैतृक नाम',
    paternalNamePlaceholder: 'पैतृक नाम दर्ज करें',
    passportIdNumber: 'पासपोर्ट आईडी नंबर',
    bankNamePlaceholder2: 'बैंक नाम चुनें',
    areaCode: 'क्षेत्र कोड',
    phoneNumberNoAreaCode: 'फ़ोन नंबर (कोई क्षेत्र कोड नहीं)',
    idType: 'आईडी प्रकार',
    idNo: 'आईडी संख्या',
    idIssueDate: 'आईडी जारी करने की तिथि',
    idExpireDate: 'आईडी समाप्ति तिथि',
    ibanStyleToast: "कृपया 'SA' से शुरू होने वाली 24 अक्षरों की सामग्री दर्ज करें।"
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'आप केवल डायमंड सेलर्स को ट्रांसफर कर सकते हैं',
    search: 'खोजें',
    history: 'ट्रांसफर किए गए उपयोगकर्ता',
    confirm_content: 'क्या आप {0} को {1} में ट्रांसफर करना सुनिश्चित करते हैं',
    success_content: '{0} को {1} में ट्रांसफर कर दिया गया है',
    purchase: 'खरीदें',
    purchase_success: 'आपने सफलतापूर्वक {0} खरीदा है',
    insufficient_balance: 'अपर्याप्त बैलेंस',
    purchase_diamond: 'हीरे खरीदें',
    transfer_limit_2: 'ट्रांसफर राशि $10 और $30,000 के बीच होनी चाहिए',
    no_data: 'कोई डेटा नहीं',
    invalid_number: 'कृपया एक वैध संख्या दर्ज करें',
    under_limit: 'ट्रांसफर राशि $10 से कम नहीं होनी चाहिए',
    over_limit: 'ट्रांसफर राशि $30,000 से कम होनी चाहिए'
  },
  redesign: {
    emailPlaceholder: 'ईमेल पता दर्ज करें',
    retrievePwd: 'पासवर्ड पुनः प्राप्त करें',
    resetPwd: 'पासवर्ड रीसेट करें',
    newPwdPlaceholder: 'नया पासवर्ड दर्ज करें',
    reenterNewPwdPlaceholder: 'नया पासवर्ड पुनः दर्ज करें',
    reenterPayPwdPlaceholder: 'कृपया भुगतान पासवर्ड पुनः दर्ज करें',
    sendToPhone: 'सत्यापन कोड आपके फ़ोन पर भेज दिया गया है',
    sendToWhatsapp: 'सत्यापन कोड आपके WhatsApp पर भेज दिया गया है',
    sendToEmail: 'सत्यापन कोड आपके ईमेल पर भेज दिया गया है',
    invalidCode: 'अमान्य कोड',
    userId: 'उपयोगकर्ता आईडी',
    other: 'अन्य',
    transactionRecord: 'लेनदेन रिकॉर्ड',
    bankCardInfo: 'बैंक कार्ड खाता',
    withdrawInfo: 'निकासी खाता',
    toFillIn: 'भरना है',
    walletInfo: 'वॉलेट खाता जानकारी',
    toComplete: 'पूरा करना है',
    verifyGuide: 'अधिक निकासी योग्यता प्राप्त करने के लिए वॉलेट खाता जानकारी पूरी करें',
    verifyNote: '{0} की दैनिक निकासी योग्यता प्राप्त करने के लिए निम्नलिखित जानकारी पूरी करें',
    verifyCompletedNote: '{0} की दैनिक निकासी योग्यता प्राप्त करने के लिए जानकारी पूरी हो गई है',
    continueBtnText: 'भरना जारी रखें',
    submitInfo: 'जानकारी सबमिट करें',
    transferAmount: 'राशि स्थानांतरित करें',
    newEmailVerify: 'नया ईमेल सत्यापन',
    verifyCodePlaceholder: 'सत्यापन कोड दर्ज करें',
    emailIncorrectToast: 'कृपया सही ईमेल पता दर्ज करें',
    newPhone: 'नया फ़ोन नंबर',
    accountAdded: 'खाता जानकारी जोड़ी गई',
    accountToAdd: 'अन्य खाते जोड़े जा सकते हैं',
    edit: 'संपादित करें',
    enterPayPwd: 'भुगतान पासवर्ड दर्ज करें',
    deleteBtnText: 'हटाएँ',
    transferTo: 'स्थानांतरित करें',
    withdrawable: 'निकासी योग्य',
    goSet: 'जाओ सेट',
    goModify: 'जाओ संशोधित'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/hi.js